import { Box } from '@wix/design-system';
import {
  STUDIO_DARK_COLOR,
  STUDIO_UNSELECTED_BORDER_COLOR,
  STUDIO_WHITE_COLOR,
} from '@wix/package-picker-shared-studio';
import { ConfirmSmall } from '@wix/wix-ui-icons-common/odeditor';
import React from 'react';

const UNSELECTED_BORDER = `1px solid ${STUDIO_UNSELECTED_BORDER_COLOR}`;

export const CYCLE_SELECTOR_CHECK_DATA_HOOKS = {
  selected: 'cycle-selector-check-selected',
  unselected: 'cycle-selector-check-unselected',
};

interface CycleSelectorCheckProps {
  isSelected: boolean;
  size: string;
}

export const CycleSelectorCheck = ({
  isSelected,
  size,
}: CycleSelectorCheckProps) => (
  <Box
    dataHook={
      isSelected
        ? CYCLE_SELECTOR_CHECK_DATA_HOOKS.selected
        : CYCLE_SELECTOR_CHECK_DATA_HOOKS.unselected
    }
    width={size}
    height={size}
    minWidth={size}
    boxSizing="border-box"
    borderRadius="50%"
    align="center"
    verticalAlign="middle"
    {...(isSelected
      ? { backgroundColor: STUDIO_DARK_COLOR, color: STUDIO_WHITE_COLOR }
      : { backgroundColor: STUDIO_WHITE_COLOR, border: UNSELECTED_BORDER })}
  >
    {isSelected && <ConfirmSmall width={size} height={size} />}
  </Box>
);
